// Sổ Xu của 1 người: mới → cũ, phân trang con trỏ 50 dòng; admin thấy ghi chú + người thao tác; thu hồi tay dòng Cộng.
import { useCallback, useEffect, useState } from "react";
import { Button, Input, Popconfirm, Table, Tag, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import { apiError, fmtNum, fmtVnDateTime, KIND_LABELS, sourceLabel } from "./xu-format-helpers";

export default function XuUserLedgerTable({ userId, refreshKey, onChanged }) {
    const [rows, setRows] = useState([]);
    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState("");

    const load = useCallback(
        async (next) => {
            setLoading(true);
            try {
                const { data } = await xuProgramApi.getLedger(userId, next);
                setRows((prev) => (next ? [...prev, ...data.data.items] : data.data.items));
                setCursor(data.data.nextCursor);
            } catch (e) {
                message.error(apiError(e, "Không tải được sổ Xu"));
            } finally {
                setLoading(false);
            }
        },
        [userId]
    );
    useEffect(() => {
        load(null);
    }, [load, refreshKey]);

    const revoke = async (id) => {
        try {
            await xuProgramApi.revokeLedger(id, reason.trim());
            message.success("Đã thu hồi");
            setReason("");
            onChanged();
        } catch (e) {
            message.error(apiError(e, "Thu hồi thất bại"));
        }
    };

    const columns = [
        { title: "Thời gian (giờ VN)", dataIndex: "createdAt", width: 150, render: fmtVnDateTime },
        {
            title: "Loại / nguồn",
            render: (_, r) => (
                <>
                    <Tag>{KIND_LABELS[r.kind] || r.kind}</Tag>
                    {sourceLabel(r.source)}
                </>
            ),
        },
        {
            title: "Xu",
            dataIndex: "delta",
            align: "right",
            render: (d, r) => (
                <span style={{ color: d >= 0 ? "#16a34a" : "#dc2626", fontWeight: 600 }}>
                    {d > 0 ? "+" : ""}{fmtNum(d)}
                    {r.rankBonus > 0 && <span className="text-gray-500 font-normal text-xs"> (gốc {fmtNum(r.baseAmount)} + hạng {fmtNum(r.rankBonus)})</span>}
                </span>
            ),
        },
        { title: "Ghi chú", dataIndex: "note", render: (n) => n || "—" },
        { title: "Người thao tác", dataIndex: "actorId", width: 110, render: (a) => (a ? `Admin #${a}` : "Hệ thống") },
        {
            title: "",
            width: 110,
            render: (_, r) =>
                r.kind !== "earn" ? null : r.revokedByLedgerId ? (
                    <Tag color="red">Đã thu hồi</Tag>
                ) : (
                    <Popconfirm
                        title="Thu hồi khoản Xu này?"
                        description={<Input placeholder="Lý do (bắt buộc)" value={reason} onChange={(e) => setReason(e.target.value)} />}
                        okText="Thu hồi"
                        cancelText="Huỷ"
                        okButtonProps={{ danger: true, disabled: reason.trim().length < 3 }}
                        onConfirm={() => revoke(r.id)}
                        onCancel={() => setReason("")}
                    >
                        <Button size="small" danger>Thu hồi</Button>
                    </Popconfirm>
                ),
        },
    ];

    return (
        <>
            <Table size="small" rowKey="id" columns={columns} dataSource={rows} loading={loading} pagination={false} scroll={{ x: 760 }} />
            {cursor && (
                <Button className="mt-2" loading={loading} onClick={() => load(cursor)}>Tải thêm 50 dòng cũ hơn</Button>
            )}
        </>
    );
}
